import React from "react";
import StatusStep from "./ui/status-step";

interface AutoStackStatusStepProps {
  isSuccess: boolean;
  onContinue: () => void;
  editStack?: boolean;
}

const AutoStackStatusStep: React.FC<AutoStackStatusStepProps> = ({
  isSuccess,
  onContinue,
  editStack = false,
}) => {
  const successConfig = {
    title: editStack
      ? "Your stack has been successfully edited."
      : "AutoStack created successfully",
    description: editStack
      ? "Keep  tracking your automated crypto purchases"
      : "Start tracking your automated crypto purchases",
    buttonText: "Done",
  };

  const failureConfig = {
    title: editStack
      ? "Failed to update your AutoStack"
      : "Failed to create your AutoStack",
    description: editStack
      ? "Start tracking your automated crypto purchases"
      : "Try again or contact support if the issue persists",
    buttonText: "Try Again",
  };

  return (
    <StatusStep
      isSuccess={isSuccess}
      onContinue={onContinue}
      successConfig={successConfig}
      failureConfig={failureConfig}
    />
  );
};

export default AutoStackStatusStep;
